import $ from 'jquery';

const initMenu = () => {
    const $siteHeader = $('#siteHeader');
    const $menu = $('#siteNav');
    const $button = $('#btnMenu');
    const $closeButton = $('.siteNav__closeButton');
    const $overlay = $('<div id="navOverlay" class="navOverlay"/>').appendTo('body');

    const isOpen = () => $menu.hasClass('visible');

    const open = () => {
        $siteHeader.addClass('navVisible');
        $button.addClass('close');
        $menu.addClass('visible');
        $overlay.addClass('visible');
    };

    const close = () => {
        $siteHeader.removeClass('navVisible');
        $button.removeClass('close');
        $menu.removeClass('visible');
        $overlay.removeClass('visible');
    };

    const toggle = (e) => {
        e.preventDefault();
        isOpen() ? close() : open();
    };

    const handleClickOutside = (e) => {
        if (isOpen() && !$menu[0].contains(e.target) && !$button[0].contains(e.target)) {
            close();
        }
    };

    const handleEscapeKey = (e) => {
        if (e.key === 'Escape' && isOpen()) {
            close();
            $button.focus();
        }
    };

    // Event Listeners
    $button.on('click', toggle);
    $closeButton.on('click', close);

    $menu.on('click', '.menu-item-has-children > .menu-item-link-wrapper', function () {
        if (window.outerWidth < 1600) {
            const $btn = $(this);
            const $item = $btn.parents('.menu-item');
            $item.toggleClass('open');
            $btn.toggleClass('open');
            $item.find('.sub-menu').slideToggle();
        }
    });

    //$menu.on('click', 'a[href*="#"]', close);

    $(window).on('scroll load', () => {
        const scrollTop = $(window).scrollTop();
        $button.toggleClass('sticky', scrollTop > 0);
    });

    $(document).on('click', handleClickOutside);
    $(document).on('keydown', handleEscapeKey);
    //$(window).on('scroll', close);
};

export default initMenu;